import React, { useState } from "react";
import {
  AccountCircleOutlined,
  ArrowDropDownRounded,
  MenuRounded,
  NotificationsNoneOutlined,
  SearchRounded,
} from "@mui/icons-material";
import {
  AppBar,
  Avatar,
  Badge,
  Box,
  Breadcrumbs,
  Button,
  Divider,
  IconButton,
  InputBase,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchLogout } from "state/userActions";
import profileImage from "assets/profile.jpeg";

const labels = {
  dashboard: "Dashboard",
  departemen: "Departemen",
  divisi: "Divisi",
  jabatan: "Jabatan",
  karyawanbaru: "Karyawan",
  stockopname: "Stock opname",
  pesertaso: "Peserta stock opname",
  absensihariini: "Absensi hari ini",
  rekapabsensiharian: "Rekap absensi harian",
  rekapabsensibulanan: "Rekap absensi bulanan",
  tabungan: "Tabungan",
  rekaptabungan: "Rekap tabungan",
  penggajian: "Gaji karyawan",
  setoran: "Setoran toko",
  alokasidc: "Alokasi DC",
  bukuwarkat: "Buku warkat",
  rolemanagement: "Role management",
};

const Navbar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const { user_data } = useSelector((state) => state.user);
  const page = labels[pathname.slice(1)] || "Workspace";
  const name = user_data?.nama_karyawan || "Workspace user";

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: alpha("#fff", 0.94),
        color: theme.palette.primary[800],
        borderBottom: `1px solid ${theme.palette.grey[100]}`,
        backdropFilter: "blur(16px)",
      }}
    >
      <Toolbar
        sx={{ minHeight: "76px !important", px: { xs: 2, md: 3.5 }, gap: 2 }}
      >
        <IconButton
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          sx={{ display: { md: "none" }, color: theme.palette.primary[700] }}
          aria-label="Buka menu"
        >
          <MenuRounded />
        </IconButton>
        <Box
          sx={{
            minWidth: { xs: 0, md: 190 },
            display: { xs: "none", sm: "block" },
          }}
        >
          <Breadcrumbs
            separator="/"
            sx={{
              "& .MuiBreadcrumbs-separator": {
                color: theme.palette.grey[300],
                mx: 0.8,
              },
            }}
          >
            <Typography
              sx={{
                color: theme.palette.grey[500],
                fontSize: 11,
                fontWeight: 600,
              }}
            >
              Workspace
            </Typography>
            <Typography
              sx={{
                color: theme.palette.primary[700],
                fontSize: 11.5,
                fontWeight: 800,
              }}
            >
              {page}
            </Typography>
          </Breadcrumbs>
          <Typography
            sx={{ mt: 0.3, fontSize: 11, color: theme.palette.grey[500] }}
          >
            Operational overview
          </Typography>
        </Box>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: { xs: "flex-start", md: "center" },
          }}
        />

        <Button
          onClick={(event) => setAnchorEl(event.currentTarget)}
          sx={{
            p: 0.25,
            minWidth: 0,
            gap: 1,
            color: theme.palette.primary[800],
          }}
        >
          <Avatar
            src={profileImage}
            alt={name}
            sx={{ width: 34, height: 34 }}
          />
          <Box
            sx={{
              display: { xs: "none", sm: "block" },
              textAlign: "left",
              maxWidth: 130,
            }}
          >
            <Typography noWrap sx={{ fontSize: 11.5, fontWeight: 800 }}>
              {name}
            </Typography>
            <Typography sx={{ color: theme.palette.grey[500], fontSize: 10 }}>
              Administrator
            </Typography>
          </Box>
          <ArrowDropDownRounded sx={{ color: theme.palette.grey[400] }} />
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MenuItem disabled>
            <AccountCircleOutlined sx={{ mr: 1.25, fontSize: 19 }} /> Akun saya
          </MenuItem>
          <Divider />
          <MenuItem onClick={() => dispatch(fetchLogout())}>
            Keluar dari Workspace
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
